export default __webpack_public_path__ + "static/192-c443c129281c2503a426a9531dab92b5.jpg";